
import { createTheme } from '@mui/material/styles';

const theme = createTheme({
    palette: {
        primary: {
          light: '#A84355',     // Rozjaśniony, lekko malinowy odcień burgundu (idealny np. na hover)
          main: '#6B1D2F',      // Głęboki, klasyczny burgund jako główny kolor przewodniczący (tła, nagłówki)
          dark: '#420D1A',      // Ciemny, niemal czekoladowy burgund do głębokich akcentów
          contrastText: '#FFFFFF', // Tekst na ciemnym burgundzie musi być biały dla czytelności
        },
        secondary: {
          light: '#F5D6BA',     // Bardzo jasny, ciepły beż/kremowy akcent (nawiązujący do tła ze zdjęcia)
          main: '#D4A373',      // Ciepłe złoto / stłumiony miodowy pomarańcz dla przycisków akcji (CTA)
          dark: '#B58253',      // Ciemniejszy odcień złota przy najechaniu myszką
          contrastText: '#1A060A', // Ciemny tekst na jasnym, złotym przycisku
        },
        background: {
          default: '#FDFBF7',   // Ciepłe, kremowe tło ścian z inspiracji
          paper: '#FFFFFF',     // Czysta biel dla kart i kontenerów
        },
        text: {
          primary: '#2C1419',   // Bardzo ciemny brąz z domieszką burgundu zamiast zwykłej czerni
          secondary: '#705A5E', // Stonowany, chłodniejszy brązowo-szary do opisów i etykiet
        },
      },
});

export default theme;